import React, { useState, useEffect } from 'react'
import { Form as FormComponent} from 'components/form/index'
import { Button, ButtonType } from 'components/button'
import { DataList } from 'components/select-advanced'
import { Input } from 'components/input/IndexAdvanced'
import CostColumnsData from '../../../views/job-costing/utils/CostColumnsData'
import { findObjById } from 'utilities/util'
import { calculateTotal, formatDropDown, checkIfSystemType, FinOpsStatusSalesOrder } from '../../../views/job-costing/utils/CostAndRevenueHelpers'
import { IUOM } from 'constants/uom.interface'
import Uom from 'constants/uom.json'
import { RadioButtonList } from 'components/radio-button/list'
import { BOOL_DROPDOWN } from 'constants/bool'
import { DISTRIBUTION_LIST } from 'constants/distribution'
import { PartyComponentNew } from '../../cost-revenue-new/dialog/PartyComponentNew'
import { ICBComponent } from '../../cost-revenue/dialog/ICBComponent'
import { costAndRevErrorMessage } from 'views/job-costing/utils/models'
import { IExportJob } from 'reducers/cbl/models'
import { PASSTHROUGH_LIST } from 'constants/passThrough';
import { SERVICE_RENDERED_OPTIONS } from 'constants/serviceRenderedOptions';
import { ATHENA } from 'constants/messages';

interface IProps {
    displayError: boolean,
    data:any,
    readonlyState: boolean,
    icbReadonlyState: boolean,
    target: any,
    reasonCodes: any[],
    type: string,
    hasSplit: boolean,
    errorList:any[],
    targetFunctionality: number,
    dropDownData: {
        chargeItem:any[],
        partyData:any
    },
    addMoreDisable: boolean,
    isQantityError: boolean,
    onUpdate: (key:any, value:any, label?: string) => void,
    onClose: () => void,
    onAddMore: () => void,
    onPartyCheckboxToggle?: (status:boolean) => void,
    showPassThrough: boolean,
    isSourceAthena?: boolean
}

export const FormAddEdit = (props: IProps) => {
  const currency = formatDropDown(CostColumnsData.DEFAULT_CURRENCY_LIST, '','')
  const icbIndicator = BOOL_DROPDOWN
  const uomConstants = Uom.filter((uomEl: IUOM) => uomEl.enabled ).map((uomEl: IUOM) => {
    return { label: uomEl.uom, value: uomEl.uom}
  })
  const setDropDownValue = (value:string|number, obj:any, propertyName:string) =>{
    const objList = findObjById(value, obj, propertyName)
    if(objList){
      return objList
    }
    return value
  }
  const checkIfReadOnly = () => {
    const statuses = props.data.children.map((obj:IExportJob) => obj.status)
    const itemNumberList = props.data.children.map((obj:IExportJob) => obj.itemNumber)
    const ifAnyStatus = statuses.some((obj:string)=> obj)
    const ifAnyItemNumber = itemNumberList.some((obj:string)=> obj)
    return props.type === 'edit' &&
            (ifAnyItemNumber && ifAnyStatus && FinOpsStatusSalesOrder(statuses))? true: false
  }
  const [isPartyCheckboxSelected, setIsPartyCheckboxSelected] = useState(false)
  const handlePartyCheckbox = (status:boolean) => {
    if(props.onPartyCheckboxToggle){
      props.onPartyCheckboxToggle(status)
    }
  }
  useEffect(() => {
    setIsPartyCheckboxSelected(props.data.isSameParty)
  }, [props.data.isSameParty])

  const checkIfSAPEdit = () => {
    return props.type === 'edit' && props.data.itemType === 'SAP'
        ? true
        : false;
  };  

  const getPassThroughValue = (passThroughValue:string) => {
    return passThroughValue === 'Y' ? 1 : (passThroughValue ? 0 : -1)
  }

  const getServiceRenderedAtValue = (value:any) => {
    if (typeof value === 'string') {
        const serviceRenderedAtMap = {
            'ORIGIN': 1,
            'DESTINATION': 2,
            'FREIGHT': 3,
        };
        return serviceRenderedAtMap[value] ? serviceRenderedAtMap[value] : '';
    }        
    return value || '';
}

  if(props.data && props.data.itemType){
    const currentData = props.data
    return(
      <FormComponent id="add-edit-component">
        <fieldset>
          <div className="grid-wrapper wrapContent">
            {!checkIfReadOnly() && props.dropDownData.chargeItem.length &&
                    <DataList
                      id="chargeItem"
                      className="col-20"
                      label={'Charge Item'}
                      value={currentData.materialCode}
                      onChange={(e:any) =>{ props.onUpdate('materialCode', e)}}
                      hasError={ props.errorList.indexOf('materialCode')>-1 }
                      error="Field is required"
                      data={checkIfReadOnly()?[setDropDownValue(currentData.materialCode, props.dropDownData.chargeItem, 'value')]: props.dropDownData.chargeItem}
                    />
            }
            {checkIfReadOnly() &&
                        <Input label={'Charge Item'}
                          className="col-20"
                          id="chargeItem"
                          value={`${currentData.materialCode} - ${currentData.materialDescription}`} type="text" readonly={true} />
            }
            <Input label={'Unit price'}
              id={'unitPrice'}
              className="col-20"
              onChange={(e:any) =>{ props.onUpdate('rate', e)}}
              value={props.data.rate}
              hasError={props.errorList.indexOf('rate')>-1}
              formatNumber={2}
              pattern="^\d{1,3}(,*\d{3}){0,2}(\.\d{1,2})?$"
              error="Field is Required, must be numeric and not exceed 9 characters and 2 decimals"
              type="text"
            />
            {currency.length > 0 &&
                    <DataList
                      id="currency"
                      className="col-20"
                      label={'Currency'}
                      value={currentData.condCurrency}
                      onChange={(e:any) =>{ props.onUpdate('condCurrency', e)}}
                      hasError={props.errorList.indexOf('condCurrency')>-1}
                      error="Field is Required"
                      data={currency} />}

            <Input
              id={'quantity'}
              className="col-20"
              label={'Quantity'}
              onChange={(e:any) =>{ props.onUpdate('quantity', e)}}
              value={props.data.quantity}
              type="text"
              readonly={(checkIfSystemType([props.data]) && checkIfReadOnly()) || (props.type !== 'add' && !currentData.displayDistribution)}
              formatNumber={3}
              hasError={props.errorList.indexOf('quantity')>-1}
              pattern="^\d{0,6}(\.\d{1,3})?$"
              error={props.isQantityError ? costAndRevErrorMessage.errorMsgQuantityNew : costAndRevErrorMessage.errorMsgQuantity}
            />
            {uomConstants.length > 0 &&
              <DataList
                label={'UOM'}
                id="unitOfMeasure"
                className="col-20"
                value={currentData.unitOfMeasure}
                onChange={(e:any) =>{ props.onUpdate('unitOfMeasure', e)}}
                hasError={ props.errorList.indexOf('unitOfMeasure')>-1 }
                error="Field is required"
                data={checkIfSystemType([props.data]) && checkIfReadOnly()?[setDropDownValue(currentData.unitOfMeasure, uomConstants, 'value')]: uomConstants} />}
            <PartyComponentNew
              dataListId="party-dropdown-main"
              className="mb-0"
              data={currentData}
              errorList={props.errorList}
              callbackDropdown={setDropDownValue}
              onUpdate={(key:string, e:any)=>{props.onUpdate(key,e)}}
              target={props.target}
              isDisabled={!isPartyCheckboxSelected}
              isCheckboxVisible={true}
              onCheckboxSelect={(status:boolean)=>{handlePartyCheckbox(status)}}
              addOrEdit={props.type}
            />
            <ICBComponent
              id="icb"
              className="col-20"
              dropdownValue={currentData.icbIndicator}
              isEditable={!props.icbReadonlyState}
              value={currentData.icbIndicator}
              onChange={(e:any) =>{ props.onUpdate('icbIndicator', e)}}
              hasError={props.errorList.indexOf('icbIndicator')>-1}
              data={icbIndicator}
            />
            <Input label={'Source Data'}
              id="sourceData"
              className="col-20"
              value={props.data.itemType} type="text" readonly={true} />
            <Input label={'Local currency'}
              className="col-20"
              id="localCurrency"
              value={props.data.condCurrency} type="text" readonly={true} />
            <Input label={'Amount'}
              id={'amount'}
              className="col-20"
              readonly={true}
              value={calculateTotal(false, currentData)}
              type="text"
            />
            <Input label={'Exchange Rate'}
              id={'exchangeRate'}
              className="col-20"
              value={props.data.exchangeRate} type="text" readonly={true} />
            <Input
              label={'Local Amount'}
              readonly={true}
              id={'localAmount'}
              className="col-20"
              value={calculateTotal(true, currentData)}
              type="text" />

            {props.type === 'edit' && props.targetFunctionality !== 5 && <div className="col-20">
              <label>
                <input type="checkbox" name="displayDistribution"
                  key={'displayDistribution-'+currentData.id}
                  id="displayDistribution"
                  defaultChecked ={currentData.displayDistribution}
                  onClick={(e:any) =>{ props.onUpdate('displayDistribution', e.currentTarget.checked) }}
                /> Re-Distribute
              </label></div>
            }

            {props.hasSplit && props.data.displayDistribution && props.targetFunctionality !== 5 &&
                <RadioButtonList
                  id="distribution"
                  label="Distribution"
                  value={currentData.distribution}
                  hasError={props.errorList.indexOf('distribution')>-1}
                  error="Field is required"
                  list={DISTRIBUTION_LIST}
                  onChange={(e:any) =>{ props.onUpdate('distribution', e)}}
                />}

              {props.showPassThrough ? (checkIfSAPEdit() ? (
                <div className="col-20">
                                        <div className="form-group">
                                            <label>
                                                <span>
                                                    Pass
                                                    through
                                                </span>
                                            </label>
                                            <br />
                                            <span className="custom-span">
                                                {getPassThroughValue(
                                                    currentData.passThrough,
                                                ) ===
                                                1
                                                    ? 'Y'
                                                    : 'N'}
                                            </span>
                                        </div>
                                    </div>
                ) : (
                <div className="col-20">
                                        <RadioButtonList
                                            id="passThrough"
                                            label="Pass Through"
                                            hasError={
                                                props.errorList.indexOf(
                                                    'passThrough',
                                                ) >
                                                -1
                                            }
                                            error="Field is required"
                                            value={getPassThroughValue(
                                                currentData.passThrough,
                                            )}
                                            list={
                                                PASSTHROUGH_LIST
                                            }
                                            onChange={(
                                                e: any,
                                            ) => {
                                                props.onUpdate(
                                                    'passThrough',
                                                    e,
                                                );
                                            }}
                                        />
                                    </div>
                )) : null}  

{props.isSourceAthena ? (currentData.itemType !== ATHENA ? (
                    <div className="col-20">
                        <RadioButtonList
                            id="serviceRenderedAt"
                            label="Service Rendered At"
                            hasError={
                                props.errorList.indexOf(
                                    'serviceRenderedAt',
                                ) >
                                -1
                            }
                            error="Field is required"
                            value={getServiceRenderedAtValue(currentData.serviceRenderedAt)}
                            list={
                                SERVICE_RENDERED_OPTIONS
                            }
                            onChange={(
                                e: any,
                            ) => {
                                props.onUpdate(
                                    'serviceRenderedAt',
                                    Number(e),
                                );
                            }}
                        />
                    </div>
                    ) : (
                    <div className="col-20">
                        <div className="form-group">
                            <label>
                                <span>
                                    Service Rendered At
                                </span>
                            </label>
                            <br />
                            <span className="custom-span">
                                {currentData.serviceRenderedAt ? currentData.serviceRenderedAt : '-'}
                            </span>
                        </div>
                    </div>
                )) : null}          

            {currentData.errorReason && currentData.errorReason.length>0 &&
                <div className="col-30">
                  <label><input type="checkbox"
                    name="handleError"
                    onChange={(e:any) =>{ props.onUpdate('handleError', e)}}
                    checked={currentData.handleError?true:false}
                  /> Clear the following error:</label>
                  <p className="status-red">{currentData.errorReason.toString()}</p>
                </div>}
            {props.type !== 'add' &&
                <DataList
                  id="reasonCode"
                  className="col-20"
                  label={'Reason Code'}
                  value={currentData.reasonCode}
                  onChange={(e:any) =>{ props.onUpdate('reasonCode', e)}}
                  hasError={ props.errorList.indexOf('reasonCode')>-1 }
                  error={costAndRevErrorMessage.validationMsgReasonCode}
                  data={props.reasonCodes} />}
          </div>
        </fieldset>
        {props.type === 'add' &&<Button
          type="button"
          id="btn-addMore"
          isDisabled={props.addMoreDisable}
          onClick={props.onAddMore}
          buttonType={ButtonType.Blue}>
                Add More
        </Button>}
      </FormComponent>
    )} else{
    return (<div />)
  }
}